import { ModalWindow, useToast } from '@cian/ui-kit';
import { ChangeEvent, FormEvent, useCallback, useRef, useState } from 'react';
import { DobroListingPopupContent } from 'shared/components/DobroListingPopupContent';
import { DobroListingPopupFooter } from 'shared/components/DobroListingPopupFooter';
import { EStatus, IOffer } from 'shared/types/listing';

export function DobroListingPopupContainer({
  offer,
  onClose,
  onUpdate,
}: {
  offer: IOffer;
  onClose: () => void;
  onUpdate: (status: EStatus, comment: string) => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const toastApi = useToast();

  const copy = useCallback(() => {
    /* istanbul ignore if */
    if (!ref.current) {
      return;
    }

    const html = ref.current.innerHTML;
    const text = ref.current.innerText;

    const listener = (e: ClipboardEvent) => {
      e.preventDefault();

      /* istanbul ignore if */
      if (!e.clipboardData) {
        return;
      }

      e.clipboardData.setData('text/html', html);
      e.clipboardData.setData('text/plain', text);
      toastApi.open({ type: 'success', text: 'Информация о заявке скопирована в буфер обмена' });
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }, [ref, toastApi]);

  const [status, setStatus] = useState(offer.status);
  const [comment, setComment] = useState(offer.comment);

  const onStatusChange = useCallback(
    (status: EStatus) => {
      setStatus(status);
    },
    [setStatus],
  );

  const onCommentChange = useCallback(
    (_: ChangeEvent, comment: string) => {
      setComment(comment);
    },
    [setComment],
  );

  const onSubmit = useCallback(
    (e?: FormEvent) => {
      e?.preventDefault();
      onUpdate(status, comment);
    },
    [onUpdate, status, comment],
  );

  return (
    <ModalWindow
      content={
        <DobroListingPopupContent
          ref={ref}
          offer={offer}
          formStatus={status}
          onFormStatusChange={onStatusChange}
          formComment={comment}
          onFormCommentChange={onCommentChange}
          onSubmit={onSubmit}
        />
      }
      footer={<DobroListingPopupFooter onCopyClick={copy} onSaveClick={onSubmit} />}
      open
      onClose={onClose}
    />
  );
}
